import { TabManager } from "../managers/TabManager";

export class TabObserver {
  constructor() {
    // Создаем экземпляр MutationObserver
    this.observer = new MutationObserver((mutationsList) => {
      mutationsList.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              // Проверяем, является ли добавленный узел контейнером вкладок
              if (node.matches('.tab-container')) {
                this.initializeTabManager(node);
              }

              // Проверяем вложенные элементы на наличие контейнеров вкладок
              if (typeof node.querySelectorAll !== 'undefined') {
                const tabContainers = node.querySelectorAll('.tab-container');
                tabContainers.forEach((container) => {
                  this.initializeTabManager(container);
                });
              }
            }
          });
        }
      });
    });

    // Начинаем наблюдение за документом
    this.observeDocument();
  }

  observeDocument() {
    this.observer.observe(document.body, {
      childList: true,
      subtree: true // Включаем наблюдение за вложенными элементами
    });

    // Инициализируем TabManager для уже существующих контейнеров
    document.querySelectorAll('.tab-container').forEach((container) => {
      this.initializeTabManager(container);
    });
  }

  initializeTabManager(container) {
    // Проверяем, есть ли уже менеджер вкладок у контейнера
    if (!container.tabManager) {
      container.tabManager = new TabManager(container);
    }
  }
}
